export default superclass => class extends superclass  {
    
    actions = {};

    newAction(name, func) {
        this.actions[name] = func;
    }

    executeAction(name) {
        this.actions[name]();
    }
}
